import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { AppState } from 'src/store/appstate';

@Injectable({
  providedIn: 'root',
})
export class RegionContextService {
  public currentRegionId$: Observable<string | undefined>;

  constructor(private store: Store<AppState>, private _viewModel: ViewModelService) {
    this.currentRegionId$ = store
      .select((x) => {
        if (x == null || x.router == null) {
          return null;
        }
        return x.router.state.params;
      })
      .pipe(
        switchMap((routeParams) => {
          if (routeParams == null) {
            return of(undefined);
          }
          const regionId = routeParams.regionId;
          if (regionId != null) {
            return of(regionId);
          }
          const cardNumber = routeParams.cardNumber;
          if (cardNumber != null) {
            return _viewModel.getCardSummaryByCardNumber(cardNumber).pipe(
              map((card) => {
                return card != null ? card.regionId : undefined;
              }),
            );
          }
          return of(undefined);
        }),
      );
  }
}
